"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M14 3c-.28 0-.53.11-.71.29L10.59 6H6c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h4.59l2.71 2.71c.17.18.42.29.7.29.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"];
//# sourceMappingURL=volume-off.js.map